import { API, Auth } from "aws-amplify";
import * as log from "loglevel";
import BasePaths from "../constants/basePaths";

const subscribeToFirebaseTopic = async (token, topic) => {
  const apiName = "WebeeAPI";
  const path = `${BasePaths.UTILITIES_BASE}/subscribe-to-topic`;
  const myInit = {
    body: {
      topic,
      token
    },
    headers: {
      language: "en"
    }
  };
  return API.post(apiName, path, myInit);
};

export const unsubscribeFromFirebaseTopic = async (token, topic) => {
  const apiName = "WebeeAPI";
  const path = `${BasePaths.UTILITIES_BASE}/unsubscribe-from-topic`;
  const myInit = {
    body: {
      topic,
      token
    },
    headers: {
      language: "en"
    }
  };
  return API.post(apiName, path, myInit);
};

export const getCurrentUser = async () => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser({
      bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    return currentUser;
  } catch (err) {
    console.error(err);
  }
};
export const updateUserAttributes = async userAttributes => {
  const user = await getCurrentUser();
  const result = await Auth.updateUserAttributes(user, userAttributes);
};

export const setFirebaseToken = async (token, userPrivileges) => {
  try {
    const attributeList = {
      "custom:staff_firebase_token": token
    };

    await updateUserAttributes(attributeList);

    const { webPushBaseTopic } = userPrivileges;

    const requestWebPushTopic = `${webPushBaseTopic}_request`;
    const bookingWebPushTopic = `${webPushBaseTopic}_booking`;

    const requestSubscriptionResponse = await subscribeToFirebaseTopic(token, requestWebPushTopic);
    const bookingSubscriptionResponse = await subscribeToFirebaseTopic(token, bookingWebPushTopic);
  } catch (err) {
    log.error(err.message);
  }
};

export const setAppPushToken = async token => {
  try {
    const currentUser = await getCurrentUser();
    const attrKey = "custom:staff_app_push_token";
    const { attributes } = currentUser;
    if (attributes.hasOwnProperty(attrKey) && attributes[attrKey] == token) {
      return;
    }
    const attributeList = {
      [attrKey]: token
    };

    await Auth.updateUserAttributes(currentUser, attributeList);
  } catch (err) {
    log.error(err.message);
  }
};
